import { TestTube } from 'lucide-react';
import { LoadingSpinner } from '../../LoadingSpinner';

interface TestingControlsProps {
  isSubmitting: boolean;
  generationProgress: string;
  session: any;
  onTestSubmit: () => void;
  onClearForm: () => void;
}

export const TestingControls = ({
  isSubmitting,
  generationProgress,
  session,
  onTestSubmit,
  onClearForm
}: TestingControlsProps) => {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
      <button
        onClick={onTestSubmit}
        disabled={isSubmitting || !session}
        className="flex items-center space-x-2 px-6 py-3 bg-accent text-surface rounded-lg font-medium hover:bg-accent/90 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
      >
        {isSubmitting ? (
          <>
            <LoadingSpinner size="sm" className="text-white" />
            <span>Generating...</span>
          </>
        ) : (
          <>
            <TestTube className="w-4 h-4" />
            <span>Test Real Generation</span>
          </>
        )}
      </button>
      
      {/* Progress Display */}
      {isSubmitting && generationProgress && (
        <div className="text-sm text-th-secondary bg-status-warning/10 px-3 py-2 rounded-lg border border-status-warning/20">
          <span className="text-status-warning font-medium">Status:</span> {generationProgress}
        </div>
      )}
      
      <button
        onClick={onClearForm}
        disabled={isSubmitting}
        className="px-6 py-3 bg-elevated border border-subtle text-th-secondary rounded-lg font-medium hover:text-th-primary hover:border-brand/50 transition-all disabled:opacity-50"
      >
        Clear Form
      </button>
    </div>
  );
};